import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ComList from '../ComList';

class SaveCurriculumVitae extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
    }

    show = (params) => {
        this.setState({
            params,
            visible: true,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    getRenderList = () => {
        const renderList = [{
            name: '简历名称',
            key: 'vitaeName',
            require: true,
            option: {
                type: 'input',
                style: { width: 200 },
                placeholder: '请输入',
            }
        }];
        return renderList;
    }

    checkValue = param => {
        const { params } = this.state;
        const { name, key, require, option, warning, display } = param;
        const { placeholder } = option;
        
        let noError = true;
        if (require) {
            if (!params[key] && !display) {
                message.warning(`${placeholder}${warning || name || ''}`);
                noError = false;
            } else {
                if (display) {
                    const { symbol, key, value = null } = display;
                    if (symbol === 'eq') {
                        if (value) {
                            const list = this.renderList || [];
                            const tar = list.find(i => i.key === key);
                            const arr = tar.option.list || [];
                            const o = arr.find(a => a.value == params[key]);
                            if (o && o.name === value && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        } else {
                            if (params[key] && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        }
                    }
                }
            }
        }
        return noError;
    }

    submit = () => {
        const { params } = this.state;
        const { userId, isChinese } = this.props;
        const renderList = this.getRenderList();
        const hasError = renderList.every(item => {
            if (Array.isArray(item)) {
                return item.every(i => this.checkValue(i));
            } else {
               return this.checkValue(item);
            }
        });
        if (!hasError) {
            return;
        }

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.createVitaeByUserId,
            data: {
                userId,
                ...params,
                typeName: isChinese ? 'CHINESE' : 'ENGLISH',
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    render() {
        const { visible, loading, params } = this.state;
        const list = this.getRenderList();
        return (
            <Modal
                title={`保存简历`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal EditPersonModal"
                confirmLoading={loading}
                maskClosable={false}
                width="400px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ComList
                            list={list}
                            params={params}
                            onChange={(value, key) => this.handleChange(value, key)}
                        />
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default SaveCurriculumVitae;


// WEBPACK FOOTER //
// ./src/components/common/generateCurriculumVitae/SaveCurriculumVitae.js